import { FileDownloadOutlined } from "@mui/icons-material";
import FileDownloadIcon from "../../assets/icons/download";
import { IconButton, Typography } from "@mui/material";
import Popover from "../base/popover";
import Button from "../base/button";
import { Box } from "@mui/system";
import React, { useContext } from "react";
import APIContext from "../../services/api/api";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { FormattedMessage } from "react-intl";

export default function Exporter({
  name,
  refVal,
  fileName,
  csvLink = "",
  headers,
  data,
  isEmpty,
  exportCSV = true,
  exportImage = true,
  downloadButtonTestId,
  pngButtonTestId
}) {
  const { getData } = useContext(APIContext);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? name : undefined;

  const handleExport = (type) => {
    switch (type) {
      case "png":
        html2canvas(refVal.current, { useCORS: true }, "autoScale").then(
          (canvas) => {
            var dataURL = canvas.toDataURL("image/png");
            var data = atob(dataURL.substring("data:image/png;base64,".length)),
              asArray = new Uint8Array(data.length);

            for (var i = 0, len = data.length; i < len; ++i) {
              asArray[i] = data.charCodeAt(i);
            }

            var blob = new Blob([asArray.buffer], { type: "image/png" });
            saveAs(blob, "photo.png");
          }
        );
        break;
      case "csv":
        getData(csvLink).then((res) => {
          const link = document.createElement("a");
          link.href = encodeURI("data:text/csv;charset=utf-8," + res);
          link.download = fileName ? fileName + ".csv" : "exported_SPOT.csv";
          document.body.appendChild(link);
          link.click();
        });
        break;
      default:
        break;
    }
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-label="download"
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        color="primary"
        disabled={isEmpty}
        data-testid={downloadButtonTestId}
        sx={{
          "& .icon-fill-primary": {
            fill: "var(--buttons-functional-content-skeleton)"
          },
          "& .icon-stroke-primary": {
            stroke: "var(--buttons-functional-content-skeleton)"
          }
        }}
      >
        <FileDownloadIcon
          opacity={isEmpty && 0.2}
          pointerEvents={isEmpty && "none"}
        />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        className="exporter-popover"
      >
        <Box
          sx={{
            minWidth: "220px",
            borderRadius: "8px",
            backgroundColor: "info.light",
            p: 3
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 2
            }}
          >
            <Typography>
              <FormattedMessage id="exportAs" />:{" "}
            </Typography>
            <IconButton
              aria-label="download as csv"
              aria-describedby={id}
              variant="contained"
              onClick={handleClose}
              color="primary"
              sx={{
                "& .icon-fill-primary": {
                  fill: "var(--buttons-functional-content-skeleton)"
                },
                "& .icon-stroke-primary": {
                  stroke: "var(--buttons-functional-content-skeleton)"
                }
              }}
            >
              <FileDownloadIcon
                alt="File download icon"
                opacity={isEmpty && 0.2}
                pointerEvents={isEmpty && "none"}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start"
            }}
          >
            {exportImage === true && (
              <Button
                aria-label="download as image"
                primary
                variant="outlined"
                onClick={() => handleExport("png")}
                data-testid={pngButtonTestId}
              >
                PNG
              </Button>
            )}
          </Box>
        </Box>
      </Popover>
    </div>
  );
}
